import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IonBadge, IonButton, IonIcon, IonMenuToggle } from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getAvailableUpdateVersionShown } from 'src/app/store/selectors/app-version.selector';

@Component({
  selector: 'app-page-menu-button',
  templateUrl: './page-menu-button.component.html',
  styleUrls: ['./page-menu-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, IonMenuToggle, IonButton, IonBadge, IonIcon]
})
export class PageMenuButtonComponent implements OnInit {
  availableUpdateVersion$: Observable<string>;

  constructor(private store: Store) {}
  ngOnInit(): void {
    this.availableUpdateVersion$ = this.store.select(getAvailableUpdateVersionShown);
  }
}
